import React, { useEffect } from "react";
import styled from "styled-components"

import Layout from "../components/layout"
import Container from "../components/container"
import PageHeader from "../components/header-page"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";

import colors from "../settings/colors"

import ReactGA from "react-ga4";
ReactGA.initialize("G-THHYTX4Y9V");

const Content = styled.div`
  padding-bottom: 75px;
  
  label {
      display: inline-block;
      margin-right: 8px;
      background-color: #333;
      padding: 6px 10px;
  }

  h3 {
      margin-top: 0px;
  }
  a {
      color: white;
  }
`
const Closed = styled.div`
  background-color: ${colors.red};
  color: white;
  padding: 10px;
  margin-bottom: 15px;
  display: inline-block;
  border-radius: 4px;
`

function ContactPage(props) {
  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: "/contact", title: "Contact Us"});
  }, []);

  return (
    <Layout page="contact" title="Contact Us">
      <Container>
        <PageHeader>Contact Us</PageHeader>
      </Container>
      <Container>
        <Content>
            <h3>Marshall Artists Series</h3>        
            <p>
                Jomie Jazz Center<br />
                One John Marshall Drive<br />
                Huntington, WV 25755-2210<br />
                (304) 696-6656<br />
                (304) 696-6658 [fax]<br />
            </p>
            <p>
                Box Office Hours 12:00 p.m. - 4:00 p.m. Monday-Friday
            </p>
            <p>
                Box Office is located in MU's Joan C. Edwards Performing Arts Center
            </p>

            {/* <Closed>
              <FontAwesomeIcon icon={faExclamationCircle} />{' '}
              Due to Covid 19 policies, the box office is currently closed.
            </Closed> */}

            <h3>Email</h3>
            <p>
                If you have any questions, comments, suggestions or would like more information,please send us an email.
            </p>
            <p>
                <label>Email Address</label>
                <a href="mailto:artistsseries@marshall.edu" mce_href="mailto:artistsseries@marshall.edu">artistsseries@marshall.edu</a>
            </p>
        </Content>
      </Container>
    </Layout>
  );
}

export default ContactPage;